<agpr-master-layout [id]="'monitoring'">
    <ng-template let-item agprTemplate="navigation">
        <agpr-left-sidebar></agpr-left-sidebar>
    </ng-template>
</agpr-master-layout>
